/* eslint-disable prettier/prettier */
import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  infoButton: {
    position: 'absolute',
    left: '0',
    bottom: '10px',
    margin: theme.spacing(1),
    borderRadius: '5em',
    height: '50px',
    width: '50px',
    backgroundColor: '#081d2e',
    color: '#fff',
      '&:hover': {
    backgroundColor: theme.palette.action.active
    }
  },
  paper: {
    overflowY: 'hidden'
  }
}))